import styled, { css } from "styled-components";

interface IProps {
  mine: boolean;
}

const StandingsRow = styled.tr<IProps>`
  ${(props) =>
    props.mine &&
    css`
      td {
        background-color: ${({ theme }) => theme.colors.secondaryTwo};
        color: ${({ theme }) => theme.colors.primary};
        > a {
          color: ${({ theme }) => theme.colors.secondaryThree};
        }
      }
    `}
`;
export default StandingsRow;
